<template>
  <div class="truemed-widget truemed-widget--old">
    <div
      id="truemed-instructions"
      data-public-id="tm_qual_cg7ybp2zmq"
    />
  </div>
</template>

<style lang="scss">
// More details about !important for the Truemed Widget can be found here:
// https://support.truemed.com/en/articles/2474177

// Scope the old global styles to the old widget to prevent any unintended consequences on the new widget
// Using a class to scope the styles instead of scoped styles because the Truemed Widget injects its own styles into the DOM that cannot be scoped
.truemed-widget--old {
  /* stylelint-disable declaration-no-important */
  .truemed-instructions-header-garmin-logo {
    height: 3rem !important;

    @include breakpoint(sm) {
      height: 3.5rem !important;
    }
  }

  .truemed-instructions-header-logo {
    height: 1rem !important;

    @include breakpoint(sm) {
      height: 1.5rem !important;
    }
  }

  .truemed-logo-img {
    height: 0.875rem !important;
  }

  .truemed-instructions {
    @include font-primary();
    font-size: $font-size-large !important;
  }

  .truemed-instructions-open {
    font-size: $font-size-large !important;
    color: $color-black !important;
  }

  .truemed-instructions-link-text {
    font-family: $font-roboto !important;
    justify-content: left !important;
    margin-bottom: 1rem !important;
  }
  /* stylelint-enable declaration-no-important */
}
</style>
